module.exports = function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_forceReduced.js
// module id = 293
// module chunks = 34471704633725 35783957827783 114276838955818 216468464745311